import React, { useMemo } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import { useIsLatam } from '../../../Region/Services/region.service';
import HealthPlanBabyCzech from './HealthPlanBabyCzech';
import HealthPlanBabyLatam from './HealthPlanBabyLatam';
import { useGetUserOriginalIdQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';

interface HealthPlanBabyProps {
	patientId: string;
	workplaceId: string;
	onHealthPlanCreate: () => void;
}

export default function HealthPlanBaby(
	props: HealthPlanBabyProps,
): JSX.Element {
	const { globalTemplate } = useAppContext();
	const isLatam = useIsLatam(globalTemplate);
	const { patientId, workplaceId, onHealthPlanCreate } = props;

	const user = useGetUserOriginalIdQuery({ id: patientId });

	const originalId = useMemo(() => {
		return user?.data?.user?.originalId ?? patientId;
	}, [user]);

	if (isLatam) return <HealthPlanBabyLatam {...props} />;

	if (!originalId) {
		return <Loading />;
	}

	return (
		<HealthPlanBabyCzech
			patientId={originalId}
			workplaceId={workplaceId}
			onHealthPlanCreate={onHealthPlanCreate}
		/>
	);
}
